import React from "react";
import { BlueBirdTheme, Button, Typography } from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import useDepartment from "../../useDepartment";

interface ModalDepartmentDeleteProps {
  isOpen: boolean;
  setClose: (modalState: boolean) => void;
  value: unknown;
  useCustomHook: ReturnType<typeof useDepartment>
}

const ModalDepartmentDelete = ({
  isOpen, setClose, value, useCustomHook,
}: ModalDepartmentDeleteProps) => {
  const { handleDelete } = useCustomHook;
  return (
    <Modal
      isOpen={isOpen}
      setOpen={setClose}
      title="Konfirmasi hapus data"
      body={
        <Typography level={5} fontWeight="medium">Apakah Anda yakin ingin menghapus data?</Typography>
      }
      footer={
        <>
          <Button
            variant="text"
            onClick={() => setClose(false)}
          >
            Batal
          </Button>
          <Button
            backgroundColor={BlueBirdTheme.colors.danger[500]}
            onClick={() => handleDelete()}
          >
            Ya, hapus
          </Button>
        </>
      }
    />
  );
};

export default ModalDepartmentDelete;
